import React from 'react';
import { TrendingUp, Target, Lightbulb } from 'lucide-react';

export default function WhoWeAre() {
  const insights = [
    {
      icon: Target,
      title: 'Capability',
      description: 'Deep market understanding rooted in data and experience.'
    },
    {
      icon: TrendingUp,
      title: 'Growth',
      description: "Aligned with India's structural growth story across cycles."
    },
    {
      icon: Lightbulb,
      title: 'Innovation',
      description: 'Adaptive strategies in a fast-evolving financial landscape.'
    },


  ];

  return (
    <section id="who-we-are" className="py-12 sm:py-16 md:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="max-w-3xl mx-auto text-center mb-10 sm:mb-12 md:mb-16">
          <h2 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl text-foreground mb-4 sm:mb-6">
            Who we are
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground leading-relaxed px-2">
            Brion Enterprises LLP is a Mumbai-based financial markets firm operating as an Authorised Person of SEBI Registered Broker. 
          </p>
          <p className="text-base sm:text-lg text-muted-foreground leading-relaxed px-2 py-4">
            We facilitate access to Indian capital markets while bringing together market research, disciplined execution and a long-term approach to building our financial markets platform.
          </p>
        </div>

        {/* Key Insights */}
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 max-w-5xl mx-auto">
          {insights.map((insight, index) => (
            <div
              key={index}
              className="group relative bg-card border border-border rounded-lg p-8 hover:shadow-lg transition-all duration-300"
            >
              <div className="mb-6">
                <div className="inline-flex items-center justify-center w-14 h-14 rounded-lg bg-accent/10 text-accent group-hover:bg-accent group-hover:text-accent-foreground transition-colors">
                  <insight.icon className="h-7 w-7" />
                </div>
              </div>
              <h3 className="font-heading font-semibold text-xl text-foreground mb-3">
                {insight.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                {insight.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}